import React from "react";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../../../shared/ui/loading/LoadingScreen";
import { AUTH_CONFIG } from "../../config";

interface Props {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: Props) => {
  const { user, status } = useAuth();

  if (status === "initializing") {
    return <LoadingScreen text="Vérification de votre session..." />;
  }

  if (!user) {
    // Sauvegarde de l'URL demandée pour y revenir après le callback
    sessionStorage.setItem("returnTo", window.location.pathname + window.location.search);

    // Construction de l'URL de redirection vers le service d'auth
    const callbackUrl = `${window.location.origin}/auth/callback`;
    const loginUrl = `${AUTH_CONFIG.AUTH_APP_URL}/auth/login?redirect=${encodeURIComponent(callbackUrl)}`;

    window.location.replace(loginUrl);
    return null;
  }

  return <>{children}</>;
};